import { __decorate, __metadata } from "tslib";
import { IsBoolean } from 'class-validator';
/**
 * HTTP request body for configuring department's support for the court system.
 */
export class ConfigureDepartmentsBody {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ConfigureDepartmentsBody.prototype, "isEnabled", void 0);
